var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseComponentPlus } from "react-vextensions";
import { Column, Row, Pre, Button, TextInput, CheckBox, Text } from "react-vcomponents";
import { GetUser, MeID, GetUserPermissionGroups } from "Store/firebase/users";
import { ShowMessageBox } from "react-vmessagebox";
import { PageContainer, Observer } from "vwebapp-framework";
import { E } from "js-vextensions";
import { PropNameToTitle } from "Utils/General/Others";
import { SetUserPermissionGroups } from "Server/Commands/SetUserPermissionGroups";
import { UpdateProfile } from "Server/Commands/UpdateProfile";
let UserProfileUI = class UserProfileUI extends BaseComponentPlus({}, {}) {
    render() {
        const { profileUser } = this.props;
        const userID = MeID();
        const profileUserPermissionGroups = GetUserPermissionGroups(profileUser ? profileUser._key : null);
        const currentUser = GetUser(userID);
        if (profileUser == null)
            return React.createElement(PageContainer, null, "User does not exist.");
        // if (currentUser == null) return <PageContainer>Must be signed-in to access.</PageContainer>;
        return (React.createElement(PageContainer, null,
            React.createElement(Row, null,
                React.createElement(Text, null,
                    "Username: ",
                    profileUser.displayName),
                profileUser == currentUser &&
                    React.createElement(Button, { ml: 5, text: "Change", onClick: () => {
                            ShowChangeDisplayNameDialog(currentUser._key, currentUser.displayName);
                        } })),
            React.createElement(Row, { mt: 3 },
                React.createElement(Pre, null, "Permissions: "),
                ["basic", "verified", "mod", "admin"].map((group, index) => {
                    const admin = userID && GetUserPermissionGroups(MeID()).admin;
                    const changingOwnAdminState = currentUser && profileUser._key == currentUser._key && group == "admin";
                    return (React.createElement(CheckBox, { key: index, mr: index < 3 ? 5 : 0, text: PropNameToTitle(group), value: (profileUserPermissionGroups || {})[group], enabled: admin && !changingOwnAdminState, onChange: val => {
                            const newPermissionGroups = E(profileUserPermissionGroups, { [group]: val });
                            new SetUserPermissionGroups({ userID: profileUser._key, permissionGroups: newPermissionGroups }).Run();
                        } }));
                }))));
    }
};
UserProfileUI = __decorate([
    Observer
], UserProfileUI);
export { UserProfileUI };
export function ShowChangeDisplayNameDialog(userID, oldDisplayName) {
    let newDisplayName = oldDisplayName;
    const valid = true;
    const boxController = ShowMessageBox({
        title: "Change display name", cancelButton: true,
        message: () => {
            boxController.options.okButtonProps = { enabled: valid };
            return (React.createElement(Column, { style: { padding: "10px 0", width: 600 } },
                React.createElement(Row, null,
                    React.createElement(Pre, null, "Display name: "),
                    React.createElement(TextInput, { value: newDisplayName, onChange: val => {
                            newDisplayName = val;
                            boxController.UpdateUI();
                        } }))));
        },
        onOK: () => {
            new UpdateProfile({ id: userID, updates: { displayName: newDisplayName } }).Run();
        },
    });
}
